module.exports = __webpack_public_path__ + "img/warehouse-package.a30a379a.svg";